<div [ngClass]="getContainerClass()">
    <span *ngIf="withLabel">
        {{ label }}
    </span>
    <span>
        {{ value ?? 0 | number : '1.' + decimals + '-' + decimals }}
    </span>
</div>
